import React, { useContext, useState } from "react"
import { faBars } from "@fortawesome/free-solid-svg-icons"
import { faHeart } from "@fortawesome/free-regular-svg-icons"
import classNames from "classnames"

import SingleGeoContext from "../../../contexts/single_geo"
import CareTypeContext from "../../../contexts/care_type"

import Icon from "../../layout/icon"
import CareSourcerLogo from "../../layout/Logo/Logo"
import SmartLink from "../../layout/SmartLink/SmartLink"
import { BROWSE_SEARCH_URL, HOME_URL } from "../../../utils/paths"

import Row from "../../layout/Row/Row"
import Stack from "../../layout/Stack/Stack"
import ButtonLink from "../../ButtonLink/ButtonLink"
import { InlineText } from "../../Typography/Typography"
import {
  LargeOnly,
  MediumAndDown,
  MediumAndUp,
  SmallOnly,
} from "../../layout/Responsive/Responsive"

import {
  hidden,
  menuButton,
  mobileNavigation,
  navItem,
  navbar,
  navigation,
  searchButton,
  stackOnSmallScreens,
  visible,
} from "./styles.module.scss"

const navbarClickEvent = (eventName, extras = {}) => ({
  name: `SEO - Navbar - ${eventName} Clicked`,
  properties: { ...extras },
})

function ShortlistLink() {
  const careType = useContext(CareTypeContext)?.careType
  const locationName = useContext(SingleGeoContext)?.locationName

  return (
    <SmartLink
      className={navItem}
      to="https://www.caresourcer.com/uk/shortlist/"
      clickEvent={navbarClickEvent("Shortlist Button", {
        careType,
        locationName,
      })}
    >
      <div className={stackOnSmallScreens}>
        <SmallOnly>
          <InlineText large light>
            <Icon icon={faHeart} />
          </InlineText>
        </SmallOnly>
        <MediumAndUp>
          <InlineText>
            <Icon icon={faHeart} />
          </InlineText>
        </MediumAndUp>
        <InlineText smSmall>
          {" "}
          Saved <MediumAndUp Element="span">homes</MediumAndUp>
        </InlineText>
      </div>
    </SmartLink>
  )
}

function NavLinks() {
  return (
    <>
      <LargeOnly>
        <ShortlistLink />
      </LargeOnly>
      <SmartLink
        className={navItem}
        to="https://www.caresourcer.com/caresupport/"
        clickEvent={navbarClickEvent("Support Link")}
      >
        <InlineText>Support & guidance</InlineText>
      </SmartLink>
      <ButtonLink
        noChevron
        to={BROWSE_SEARCH_URL}
        clickEvent={navbarClickEvent("CTA Button")}
        className={classNames(searchButton, navItem)}
      >
        Start finding care
      </ButtonLink>
    </>
  )
}

export default function Navbar() {
  const [showMobileMenu, setShowMobileMenu] = useState(false)
  const toggleMobileMenu = () => setShowMobileMenu(!showMobileMenu)

  return (
    <div className={navigation}>
      <Row spaceBetween verticallyCentre className={navbar}>
        <SmartLink
          noHoverStyle
          to={HOME_URL}
          clickEvent={navbarClickEvent("Logo")}
          aria-label="Care Sourcer heart logo with company name text"
        >
          <CareSourcerLogo />
        </SmartLink>

        <nav>
          <LargeOnly>
            <Row verticallyCentre>
              <NavLinks />
            </Row>
          </LargeOnly>
          <MediumAndDown>
            <Row verticallyCentre>
              <ShortlistLink />
              <button
                type="button"
                className={menuButton}
                onClick={toggleMobileMenu}
                aria-label={
                  showMobileMenu
                    ? "Close navigation menu"
                    : "Open navigation menu"
                }
              >
                <Icon icon={faBars} />
              </button>
            </Row>
          </MediumAndDown>
        </nav>
      </Row>
      <MediumAndDown>
        <div
          className={classNames(mobileNavigation, {
            [visible]: showMobileMenu,
            [hidden]: !showMobileMenu,
          })}
        >
          <Stack>
            <NavLinks />
          </Stack>
        </div>
      </MediumAndDown>
    </div>
  )
}
